import { MY_STATES, mergeStateRates, type ShippingStateRate } from "@gaole/shared";
import { NumberField } from "../../components/ui";

export function ShippingRatesEditor({
  value,
  fallbackFee,
  onChange,
}: {
  value: unknown;
  fallbackFee: number;
  onChange: (rates: ShippingStateRate[]) => void;
}) {
  const rates = mergeStateRates(value, fallbackFee);

  function setFee(state: string, fee: number) {
    onChange(rates.map((row) => (row.state === state ? { ...row, fee } : row)));
  }

  return (
    <div className="overflow-hidden rounded-xl border border-line">
      <div className="grid grid-cols-[minmax(0,1fr)_120px] gap-3 border-b border-line bg-surface-2 px-3 py-2 text-[10px] font-semibold uppercase tracking-widest text-muted">
        <span>State</span>
        <span className="text-right">Fee (MYR)</span>
      </div>
      <div className="max-h-[420px] overflow-y-auto">
        {MY_STATES.map((s) => {
          const row = rates.find((r) => r.state === s.label)!;
          return (
            <div
              key={s.code}
              className="grid grid-cols-[minmax(0,1fr)_120px] items-center gap-3 border-b border-line/60 px-3 py-2 last:border-b-0"
            >
              <span className="text-sm text-foreground">{s.label}</span>
              <NumberField
                decimal
                min={0}
                step="0.01"
                className="text-right"
                value={row.fee}
                onChange={(fee) => setFee(s.label, fee)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
